import { ComponentPropsWithoutRef } from "react";
/* eslint-disable sonarjs/no-duplicate-string */
import { Partner } from "Store/partners/partnerInterfaces";
import { isAkademikerneTheme } from "Utils/partnerUtils";
import { getPartnerLogo } from "./partnerLogos";

type ReactImage = ComponentPropsWithoutRef<"img">;

interface NavbarProps {
  show?: {
    toggles?: {
      notifications?: boolean;
      menu?: boolean;
    };
  };
  logo?: {
    desktop: ReactImage;
    mobile: ReactImage;
  };
  addons?: {
    logo: ReactImage;
    text: string;
  };
}

export const getNavbarPartnerProps = (partnerId: Partner): NavbarProps => {
  if (isAkademikerneTheme(partnerId)) {
    return getNavbarAkaProps(partnerId);
  }

  switch (partnerId) {
    case Partner.COOP:
      return NAVBAR_COOP_PROPS;
    case Partner.DANSKE_BANK:
      return NAVBAR_DANSKE_BANK_PROPS;
    case Partner.HUSEIERNE:
      return NAVBAR_HUSEIERNE_PROPS;
    default:
      return {};
  }
};

const getNavbarAkaProps = (partnerId: Partner): NavbarProps => {
  const logoUrl = getPartnerLogo(partnerId);
  return {
    logo: {
      desktop: {
        src: logoUrl,
        alt: `Akademikerne ${partnerId} logo`,
        style: {
          height: "56px",
          width: "auto",
        },
      },
      mobile: {
        src: logoUrl,
        alt: `Akademikerne ${partnerId} logo`,
        style: {
          height: "48px",
          width: "auto",
        },
      },
    },
  };
};

const NAVBAR_COOP_PROPS: NavbarProps = {
  addons: {
    text: "I samarbeid med",
    logo: {
      src: getPartnerLogo(Partner.COOP),
      alt: "Storebrand",
      height: "16px",
    },
  },
};

const NAVBAR_DANSKE_BANK_PROPS: NavbarProps = {
  addons: {
    text: "I samarbeid med",
    logo: {
      src: getPartnerLogo(Partner.DANSKE_BANK),
      alt: "Danske bank",
      height: "24px",
    },
  },
};

const NAVBAR_HUSEIERNE_PROPS: NavbarProps = {
  addons: {
    text: "I samarbeid med",
    logo: {
      src: getPartnerLogo(Partner.HUSEIERNE),
      alt: "Huseierne",
      height: "16px",
    },
  },
};
